/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDomainHosterFromJSON, ApiDomainHosterToJSON, } from './ApiDomainHoster';
import { ApiDomainStatusFromJSON, ApiDomainStatusToJSON, } from './ApiDomainStatus';
export function ApiDomainResponseFromJSON(json) {
    return ApiDomainResponseFromJSONTyped(json, false);
}
export function ApiDomainResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'certificateApproved': !exists(json, 'certificateApproved') ? undefined : (new Date(json['certificateApproved'])),
        'certificateCname': !exists(json, 'certificateCname') ? undefined : json['certificateCname'],
        'certificateCnameValue': !exists(json, 'certificateCnameValue') ? undefined : json['certificateCnameValue'],
        'cnameName': !exists(json, 'cnameName') ? undefined : json['cnameName'],
        'cnameValue': !exists(json, 'cnameValue') ? undefined : json['cnameValue'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'domainApproved': !exists(json, 'domainApproved') ? undefined : (new Date(json['domainApproved'])),
        'hoster': !exists(json, 'hoster') ? undefined : ApiDomainHosterFromJSON(json['hoster']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'readyAt': !exists(json, 'readyAt') ? undefined : (new Date(json['readyAt'])),
        'status': !exists(json, 'status') ? undefined : ApiDomainStatusFromJSON(json['status']),
        'subdomain': !exists(json, 'subdomain') ? undefined : json['subdomain'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function ApiDomainResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'certificateApproved': value.certificateApproved === undefined ? undefined : (value.certificateApproved.toISOString()),
        'certificateCname': value.certificateCname,
        'certificateCnameValue': value.certificateCnameValue,
        'cnameName': value.cnameName,
        'cnameValue': value.cnameValue,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'description': value.description,
        'domain': value.domain,
        'domainApproved': value.domainApproved === undefined ? undefined : (value.domainApproved.toISOString()),
        'hoster': ApiDomainHosterToJSON(value.hoster),
        'id': value.id,
        'name': value.name,
        'readyAt': value.readyAt === undefined ? undefined : (value.readyAt.toISOString()),
        'status': ApiDomainStatusToJSON(value.status),
        'subdomain': value.subdomain,
        'url': value.url,
    };
}
